import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Stepper.scss';

/* eslint-disable no-underscore-dangle */

/*
Stepper, how to use it:

  1. import to your component Stepper and Step objects from this file
  2. call Stepper and Step components in your component for example:
      <Stepper>
        <Step title="your_title_1" url="your_url_1"/>
        ...
        <Step title="your_title_n" url="your_url_n"/>
      </Stepper>

*/

class Stepper extends Component {
  render() {
    return (
      <div className="stepper">
        {/* <StepOne title="Kroczek 1" /> */}
        {this.props.children.map((v, i) => {
          let _isFirst = false;
          let _isLast = false;
          if (i === 0) _isFirst = true;
          if (i === this.props.children.length - 1) _isLast = true;
          return React.cloneElement(v, { key: i, _isFirst, _isLast });
        })}
      </div>
    );
  }
}

Stepper.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
  ]).isRequired,
};

const DoubleChevron = () => (
  <span style={{ margin: '0 20px' }}>
    <span className="fa fa-chevron-left fa-1x" aria-hidden="true" />
    <span className="fa fa-chevron-left fa-1x" aria-hidden="true" />
  </span>
);

export const Step = (props) => (
  <div style={{ display: 'flex' }}>
    {!props._isFirst ? <DoubleChevron /> : null }
    {!props._isLast ? <a href={props.url}>{props.title}</a> : <span>{props.title}</span> }
  </div>
);

Step.propTypes = {
  title: PropTypes.string.isRequired, // Text rendere in step
  url: PropTypes.string, // Text rendere in step
  _isFirst: PropTypes.bool, // whether or not is this a first step in stepper
  _isLast: PropTypes.bool, // whether or not is this a last step in stepper
};

export default withStyles(s)(Stepper);



// WEBPACK FOOTER //
// src/components/Stepper/Stepper.js